<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { DownOutlined } from '@ant-design/icons-vue';
import { computed, watch, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router'
const router = useRouter()
const route = useRoute()

const { locale } = useI18n()
const lang = ref(localStorage.getItem('lang') || 'zh-CN')

// 切换语言函数
const changeLanguage = (lang: any) => {
    locale.value = lang.key
    lang.value = lang.key
    localStorage.setItem('lang', lang.key) // 持久化保存
    router.replace({ query: { ...route.query, zone: lang.key } })
}

</script>

<template>
    <div class="lang">
        <a-dropdown>
            <a class="ant-dropdown-link" @click.prevent>
                {{ locale == 'zh-CN' ? '简体中文' : 'English' }}
                <DownOutlined />
            </a>
            <!-- 正确：使用 template #overlay -->
            <template #overlay>
                <a-menu @click="changeLanguage">
                    <a-menu-item key="zh-CN">
                        简体中文
                    </a-menu-item>
                    <a-menu-item key="en-US">
                        English
                    </a-menu-item>
                </a-menu>
            </template>
        </a-dropdown>
    </div>
</template>


<style>
.lang {
    display: flex;
    justify-content: flex-end;
    font-size: 14px;
    color: #000000;
}

.ant-dropdown-link {
    color: #000000;
}
</style>
